import { mapErrorToUserMessage, transformN8NResponse } from "./utils";
import type { FormData, GeneratedLesson } from "./types";

const N8N_WEBHOOK_URL =
  (import.meta.env?.VITE_N8N_LESSON_WEBHOOK as string | undefined) ||
  "https://brennovic08.app.n8n.cloud/webhook/11d239d1-88ab-47d7-af7c-316f4e863405";

export async function generateLesson(
  formData: FormData,
  onLoadingMessage: (msg: string) => void,
): Promise<GeneratedLesson> {
  try {
    onLoadingMessage("Conectando ao servidor N8N...");

    // Formatar payload exatamente como CreateLessonPlanAI faz
    const payload = {
      titulo: formData.title || `Aula sobre ${formData.topic}`,
      disciplina: formData.subject,
      serie: formData.grade,
      tema: formData.topic,
      objetivo: formData.objectives || "",
      tipo_aula: formData.lessonType,
      duracao: `${formData.duration} minutos`,
      nivel_dificuldade: formData.difficulty,
      quantidade_alunos: formData.studentsCount,
      incluir_atividades: formData.includeActivities,
      incluir_materiais: formData.includeMaterials,
      incluir_avaliacao: formData.includeAssessment,
      instrucoes_personalizadas: formData.customInstructions || "",
      origem: "webapp",
      data_solicitacao: new Date().toISOString(),
    };

    console.log("📤 Enviando requisição para N8N:", payload);

    onLoadingMessage("Enviando dados para a IA...");

    const response = await fetch(N8N_WEBHOOK_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    console.log("📨 Status da resposta N8N:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("❌ Erro da resposta:", errorText);
      throw new Error(`Erro HTTP ${response.status}: ${errorText}`);
    }

    onLoadingMessage("Processando resposta da IA...");
    const result = await response.json();

    console.log("✅ Resposta recebida do N8N:", result);

    if (!result.success) {
      throw new Error(result.error || "Erro ao gerar plano de aula");
    }

    // Transformar dados do N8N para o formato esperado pelo componente
    const lessonData = transformN8NResponse(result, formData);
    return lessonData;
  } catch (err: any) {
    console.error("❌ Erro ao gerar aula:", err);
    const errorMessage = mapErrorToUserMessage(err);
    throw new Error(errorMessage);
  }
}
